// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useMutation } from '@tanstack/react-query';
import { useLoggedInUser } from '../../../contexts/UserProvider';
import {
  reprocessDepositAttestations,
  ReprocessDepositAttestationRequest,
} from '../../../utils/operationalApi';

const useReprocessAttestations = () => {
  const { userAccessToken } = useLoggedInUser();

  return useMutation({
    mutationKey: ['reprocessAttestations'],
    mutationFn: (request: ReprocessDepositAttestationRequest) =>
      reprocessDepositAttestations(userAccessToken, request),
  });
};

export default useReprocessAttestations;
